const body = document.body;
const header = document.querySelector(".header");
const heroComponents = document.querySelectorAll(".hero");
const logo = document.querySelector(".header__logo");
const logoBgHeight = 129;

window.addEventListener(
  "scroll",
  function () {
    if (!header) {
      return false;
    }

    if (window.pageYOffset > logoBgHeight) {
      body.classList.add("header-fixed");
      logo.classList.remove("visible");
    } else {
      body.classList.remove("header-fixed");
      logo.classList.add("visible");
    }

    if (window.pageYOffset > logoBgHeight + 320) {
      header.classList.add("active");
      header.classList.remove("light-buttons");
    } else {
      header.classList.remove("active");

      if (heroComponents.length) {
        header.classList.add("light-buttons");
      }
    }
  },
  false
);

if (header) {
  if (heroComponents.length) {
    header.classList.add("light-buttons");
    logo.classList.add("visible");
  } else {
    body.style.paddingTop = `${logoBgHeight}px`;
  }
}
